import React from 'react';
import cn from 'clsx';
import { DisplayPreview } from './display-preview';
import styles from './style.module.scss';
import Card from '@components-clean/core/card';
import InfoCircleExclamationIcon from '@components-clean/core/icons/info-circle-exclamation-icon';
import { InfoField } from '@components-clean/core/info-field';
import { useLocalState, useTranslation } from '@hooks/index';
import { panel_OpraQueries_panel_Panel } from '@queries/generated/central-monitoring.generated';

type PanelProps = {
    processedConfig?: panel_OpraQueries_panel_Panel;
    currentConfig?: panel_OpraQueries_panel_Panel;
    isValidConfig: boolean;
};

export const PanelPreview = ({ processedConfig, currentConfig, isValidConfig }: PanelProps) => {
    const { t: tManagePanels } = useTranslation('admin', { keyPrefix: 'managePanels' });
    const { t } = useTranslation('cm', { keyPrefix: 'componentsClean.panels' });
    const { state } = useLocalState();
    const titleComponent = (message: string, iconText: string) => (
        <div className="k-d-flex k-gap-2">
            {tManagePanels(message)}
            <InfoCircleExclamationIcon
                dataTestId="info-for-previous-config"
                title={tManagePanels(iconText)}
                tooltipPosition="bottom"
                className={styles.rotateIcon}
            />
        </div>
    );

    return (
        <div className={cn(styles.preview, 'k-overflow-y-auto')}>
            <Card
                title={titleComponent('previousConfig', 'previousConfigInfo')}
                data-testid="tri-ops-date-previous-config-preview"
                className={cn(styles.cardHeight)} // Setting the card height for the chart container so that chart doesn't grow with the splitter
            >
                <div className="k-overflow-y-auto k-h-full">
                    {processedConfig && (
                        <DisplayPreview studyRef={state?.selectedStudy?.id} panelConfig={processedConfig} />
                    )}
                    {!processedConfig && (
                        <div className="k-d-flex k-h-full k-justify-content-center">
                            <InfoField message={t('noData')} type="Info" layout="center" />
                        </div>
                    )}
                </div>
            </Card>
            <Card
                title={titleComponent('currentConfig', 'currentConfigInfo')}
                data-testid="tri-ops-date-current-config-preview"
                className={cn(styles.cardHeight)}
            >
                <div className="k-overflow-y-auto k-h-full">
                    {currentConfig && isValidConfig && (
                        <DisplayPreview studyRef={state?.selectedStudy?.id} panelConfig={currentConfig} />
                    )}
                    {(!currentConfig || !isValidConfig) && (
                        <div className="k-d-flex k-h-full k-justify-content-center">
                            <InfoField message={t('noData')} type="Info" layout="center" />
                        </div>
                    )}
                </div>
            </Card>
        </div>
    );
};
